import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Unauthorized from "../pages/Unauthorized";
import ProtectedRoute from "../components/ProtectedRoute";
import AffiliateLogin from "../pages/AffiliateLogin";
import Courses from "../pages/Courses";
import Lectures from "../pages/Lectures/Lectures";

const AppRouter = () => (
  <Router>
    <Routes>
      {/* Home route, protected */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Unauthorized />
          </ProtectedRoute>
        }
      />

      {/* Public routes */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/affiliate/:loginkey" element={<AffiliateLogin />} />

      {/* Protected routes */}
      <Route
        path="/courses"
        element={
          <ProtectedRoute>
            <Courses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lectures/:courseid/:coursename"
        element={
          <ProtectedRoute>
            <Lectures />
          </ProtectedRoute>
        }
      />

      {/* Catch-all route for unknown paths */}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <Unauthorized />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Router>
);

export default AppRouter;
